import { render } from "./UsuarioForm.vue?vue&type=template&id=23da689b&scoped=true"
import script from "./UsuarioForm.vue?vue&type=script&lang=js"
export * from "./UsuarioForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=23da689b&scoped=true&lang=css"
import "./UsuarioForm.vue?vue&type=style&index=1&id=23da689b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23da689b"]])

export default __exports__